module.exports = __webpack_public_path__ + "static/media/Piercing-microdermal-chest-1.d0092e2c.png";